import { ActionCreator } from 'redux';
import { UserAgentStats, Channel, CampaignInfo } from '@dev/ee-api/ee-api-models';

import {
    DevicesParamsInterface,
    DevicesChannelParamsInterface,
    DevicesFetchStartAction,
    DevicesFetchSuccessAction,
    DevicesFetchErrorAction,
    AllChannelsFetchStartAction,
    AllChannelsFetchSuccessAction,
    AllChannelsFetchErrorAction,
    AllCampaignsFetchStartAction,
    AllCampaignsFetchSuccessAction,
    AllCampaignsFetchErrorAction,
    DevicesChannelFetchStartAction,
    DevicesChannelFetchSuccessAction,
    DevicesChannelFetchErrorAction,
} from './types';

export const StartAllChannelsLoading: ActionCreator<AllChannelsFetchStartAction> = (): AllChannelsFetchStartAction => ({
    type: '@@allchannels/FETCH_START',
    payload: {
        loading: true,
    },
});

export const AllChannelsLoadedSuccess: ActionCreator<AllChannelsFetchSuccessAction> = (
    channels: Channel[]
): AllChannelsFetchSuccessAction => ({
    type: '@@allchannels/FETCH_SUCCESS',
    payload: {
        loading: false,
        channels,
    },
});

export const AllChannelsLoadedError: ActionCreator<AllChannelsFetchErrorAction> = (): AllChannelsFetchErrorAction => ({
    type: '@@allchannels/FETCH_ERROR',
    payload: {
        loading: false,
    },
});

export const StartAllCampaignsLoading: ActionCreator<
    AllCampaignsFetchStartAction
> = (): AllCampaignsFetchStartAction => ({
    type: '@@allcampaigns/FETCH_START',
    payload: {
        loading: true,
    },
});

export const AllCampaignsLoadedSuccess: ActionCreator<AllCampaignsFetchSuccessAction> = (
    campaigns: CampaignInfo[]
): AllCampaignsFetchSuccessAction => ({
    type: '@@allcampaigns/FETCH_SUCCESS',
    payload: {
        loading: false,
        campaigns,
    },
});

export const AllCampaignsLoadedError: ActionCreator<
    AllCampaignsFetchErrorAction
> = (): AllCampaignsFetchErrorAction => ({
    type: '@@allcampaigns/FETCH_ERROR',
    payload: {
        loading: false,
    },
});

export const StartUserAgentLoading: ActionCreator<DevicesFetchStartAction> = (
    params: DevicesParamsInterface
): DevicesFetchStartAction => ({
    type: '@@devices/FETCH_START',
    payload: {
        loading: true,
        from: params.from,
        to: params.to,
    },
});

export const UserAgentLoadingFinished: ActionCreator<DevicesFetchSuccessAction> = (
    userAgent: UserAgentStats[]
): DevicesFetchSuccessAction => ({
    type: '@@devices/FETCH_SUCCESS',
    payload: {
        loading: false,
        userAgent,
    },
});

export const UserAgentLoadingError: ActionCreator<DevicesFetchErrorAction> = (): DevicesFetchErrorAction => ({
    type: '@@devices/FETCH_ERROR',
    payload: {
        loading: false,
    },
});

export const StartUserAgentChannelLoading: ActionCreator<DevicesChannelFetchStartAction> = (
    params: DevicesChannelParamsInterface
): DevicesChannelFetchStartAction => ({
    type: '@@deviceschannel/FETCH_START',
    payload: {
        loading: false,
        name: params.name,
        from: params.from,
        to: params.to,
    },
});

export const UserAgentChannelLoadingFinished: ActionCreator<DevicesChannelFetchSuccessAction> = (
    userAgent: UserAgentStats[]
): DevicesChannelFetchSuccessAction => ({
    type: '@@deviceschannel/FETCH_SUCCESS',
    payload: {
        loading: false,
        userAgent,
    },
});

export const UserAgentChannelLoadingError: ActionCreator<
    DevicesChannelFetchErrorAction
> = (): DevicesChannelFetchErrorAction => ({
    type: '@@deviceschannel/FETCH_ERROR',
    payload: {
        loading: false,
    },
});
